import { useBilling } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { useAppSelector } from '@store/hooks'
import { CheckBox, FormButton, FormInputField, ModalHeader, SelectInputField } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form, Layer, Text } from 'grommet'
import { useMemo } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { InvoicePayload, invoiceSchema } from './AddItem'

type Props = {
  onClose: () => void
  id?: string
  category?: string
  name?: string
  quantity?: string
  unit_price?: string
  bill_to_hmo?: boolean
}

export const EditItem = ({ onClose, ...rest }: Props) => {
  const stateCategory = useAppSelector(state => state.config.invoice_item_category)
  const { updateItem } = useBilling({})

  const category = useMemo(() => {
    return stateCategory?.map(item => ({
      name: item.replace(/_/g, ' '),
      value: item
    }))
  }, [stateCategory])

  const methods = useForm({
    resolver: yupResolver(invoiceSchema),
    values: {
      bill_to_hmo: rest.bill_to_hmo || false,
      category: rest.category?.replace(/ /g, '_') || '',
      name: rest.name || '',
      quantity: rest.quantity || '',
      unit_price: rest.unit_price || ''
    }
  })
  const {
    handleSubmit,
    control,
    formState: { isSubmitting }
  } = methods

  const onSubmit = async (formVal: InvoicePayload) => {
    const payload = {
      data: {
        attributes: {
          ...formVal
        },
        type: 'invoice_item'
      }
    }

    try {
      await updateItem({ formVal: payload, id: rest?.id || '' })
      showToast('Invoice item updated successfully')
      onClose()
    } catch (error) {
      getError(error)
    }
  }
  return (
    <FormProvider {...methods}>
      <Layer
        margin={{ vertical: '8px' }}
        modal
        onClickOutside={onClose}
        onEsc={onClose}
        position="center"
        style={{ borderRadius: '15px' }}
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box style={{ maxHeight: '88vh', minWidth: 'min(450px, calc(100vw - 1.5rem))' }}>
            <ModalHeader onClose={onClose} title="Edit item" />
            <Box gap={'24px'} overflow={'auto'} pad={'medium'}>
              <Box>
                <SelectInputField
                  disabled
                  dropProps={{
                    align: { left: 'left', right: 'right', top: 'bottom' },
                    height: '300px'
                  }}
                  label="Category"
                  labelKey={'name'}
                  name="category"
                  options={category}
                  valueKey={{ key: 'value', reduce: true }}
                />
              </Box>
              <Box>
                <FormInputField disabled label="Name" name="name" placeholder="E.g Paracetamol" />
              </Box>
              <Box>
                <FormInputField label="Unit pricing" name="unit_price" placeholder="" />
              </Box>
              <Box>
                <FormInputField label="Quantity/Duration" name="quantity" placeholder="" type="number" />
              </Box>
              <Controller
                control={control}
                name="bill_to_hmo"
                render={({ field: { onChange, value } }) => (
                  <Box direction="row" gap={'5px'}>
                    <CheckBox
                      checked={value}
                      handleChange={arg => {
                        onChange(arg)
                      }}
                    />
                    <Text size="14px">Bill to HMO</Text>
                  </Box>
                )}
              />
            </Box>
            <FormButton isLoading={isSubmitting} onClose={onClose} submit="Update" />
          </Box>
        </Form>
      </Layer>
    </FormProvider>
  )
}
